export default __webpack_public_path__ + "static/media/_dkg_gyn-dys-sprechstd_rgb.7a4a1690.svg";